<template lang="html">

  <section class="actualidad">

    <section class="filtro">
      <input type="text" v-model="filtros.search">
      <select v-model="filtros.categoria">
        <option value="">Selecciona categoria</option>
        <option :value="categoria.slug" v-for="(categoria, key) in categorias" :key="key">{{categoria.nombre}}</option>
      </select>
    </section>

    <noticia v-for="(noticia, key) in noticias(filtros)" :key="key" :data="noticia"></noticia>

  </section>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex'

  import noticia from '@/components/parts/noticia-el'

  export default  {
    name: 'actualidad',
    props: [],
    created() {
      this.requestNoticias();
    },
    data() {
      return {
        filtros : {
          search : '',
          categoria : ''
        }
      }
    },
    methods: {
      ...mapActions(['requestNoticias'])
    },
    computed: {
      ...mapGetters({
        categorias : 'categoriaNoticias',
        noticias : 'getNoticiasFiltradas'
      })
    },
    components : {
      'noticia' : noticia
    }
  }
</script>

<style scoped lang="scss">
.actualidad {

}
</style>



// WEBPACK FOOTER //
// src/components/views/actualidad.vue